{
  "navigation": {
    "dashboard": {
      "label": "Dashboard"
    },
    "tenantUsersMngt": {
      "label": "Users management"
    },
    "tenantSettingsMngt": {
      "label": "Tenant settings"
    },
    "tenantAuditLogsMngt": {
      "label": "Audit/Activity logs"
    },
    "powerAdminDbTenantMngt": {
      "label": "DB Tenats management"
    },

    "environments": {
      "label": "Environments"
    },
    "apps": {
      "label": "Apps"
    },
    "flows": {
      "label": "Flows"
    },
    "desktopFlows": {
      "label": "Desktop Flows"
    },
    "bots": {
      "label": "Bots"
    },
    "formGenerator": {
      "label": "Form generator"
    },
    "compliance": {
      "label": "Compliance Management"
    },
    "expand": {
      "label": "Expand/Collapse"
    },
    "signOut": {
      "label": "Sign out"
    },
    "darkMode": {
      "label": "Toggle Mode"
    },
    "notDarkMode": {
      "label": "Toggle Mode"
    }
  },
  "navigationTenant": {
    "roles": {
      "label": "Roles: "
    }
  },
  "tenantSettingsMngt": {
    "overview": {
      "title": "Tenant settings management",
      "subtitle": "All your data at once"
    },
    "field": {
      "inactivityDaysReminder": {
        "label": "Inactivity Reminder (every X Days)"
      },
      "inactivityAction": {
        "placeholder": "Choose action",
        "label": "Perform action after reminder",
        "options": {
          "NOTHING": "Do nothing",
          "AUTODELETE": "Delete automatically"
        }
      },
      "inactivityActionValueAutoDelete": {
        "label": "After X Days",
        "placeholder": "Enter number of days"
      }
    }
  },
  "tenantAuditLogsMngt": {
    "overview": {
      "title": "Tenant audit logs",
      "subtitle": "All your data at once"
    },
    "field": {
    },
    "table": {
      "action": {
        "info": "See form"
      },
      "column": {
        "description": {
          "label": "Description"
        },
        "createdAt": {
          "label": "Time"
        }
      }
    }
  },
  "dashboard": {
    "overview": {
      "title": "Dashboard",
      "subtitle": "All your data at once",
      "messages": {
        "tenantLinkBrokenNeededAdmin" : "Impliancy lacks required permissions for one or more environments. Displayed data may be incomplete. Please contact an admin.",
        "tenantLinkBrokenAdmin": "Impliancy does not have the required environment permissions. Click here to grant access.",
        "tenantLinkBrokenAdminAction": "Grant Access",
        "tenantLinkingBrokenAdminAction": "Please wait...",
        "tenantLinkBrokenAdminActionTitle": "Unlinked Tenant Found:"
      }
    },
    "cards": {
      "users": {
        "label": "USERS"
      },
      "environments": {
        "label": "ENVIRONMENTS"
      },
      "apps": {
        "label": "APPS"
      },
      "flows": {
        "label": "FLOWS"
      },
      "desktopFlows": {
        "label": "DESKTOP FLOWS"
      },
      "bots": {
        "label": "BOTS"
      }
    }
  },
  "compliance": {
    "overview": {
      "title": "Compliance Management",
      "subtitle": "All your compliance at once"
    },
    "tabs": {
      "ENVIRONMENT": {
        "label": "Environments"
      },
      "APP": {
        "label": "Apps"
      },
      "FLOW": {
        "label": "Flows"
      },
      "DESKTOPFLOW": {
        "label": "Desktop flows"
      },
      "BOT": {
        "label": "Bots"
      }
    },
    "actions": {
      "addForm": {
        "label": "Add form"
      }
    },
    "table": {
      "action": {
        "info": "See form"
      },
      "flag": {
        "isActive": {
          "label": "Active",
          "tooltip": "Active"
        },
        "isInactive": {
          "label": "Inactive",
          "tooltip": "Inactive"
        }
      },
      "column": {
        "name": {
          "label": "Name"
        },
        "created": {
          "label": "Created"
        },
        "lastModified": {
          "label": "Modified"
        },
        "isActive": {
          "label": "Status"
        }
      }
    },
    "forms": {
      "updateComplianceForm": {
        "button": {
          "submit": {
            "label": "Update form"
          }
        }
      },
      "addComplianceForm": {
        "button": {
          "submit": {
            "label": "Create form"
          }
        },
        "field": {
          "name": {
            "label": "Name"
          },
          "description": {
            "label": "Description"
          },
          "file": {
            "label": "Form file (.json)"
          },
          "form": {
            "label": "Form"
          }
        }
      }
    }
  },
  "miscellaneous": {
    "action": {
      "change": "Change",
      "refresh": "Refresh",
      "clear": "Clear"
    },
    "owner": {
      "label": "Owner"
    },
    "deputies": {
      "label": "Deputies"
    },
    "shared": {
      "label": "Shared with"
    },
    "settings": {
      "label": "Settings"
    },
    "searchUsers": {
      "label": "Search users"
    },
    "assignedUsers": {
      "label": "Assigned users"
    }
  },
  "powerAdminTenantsMngt": {
    "overview": {
      "title": "DB Tenants",
      "subtitle": "All your db tenants"
    },
    "table": {
      "column": {
        "tenant": {
          "label": "Tenant"
        },
        "dbUsersCount": {
          "label": "Users in DB"
        },
        "systemUsersCount": {
          "label": "Users in System"
        },
        "createdAt": {
          "label": "Created At"
        }
      }
    }
  },
  "tenantUsersMngt": {
    "overview": {
      "title": "Tenant Users",
      "subtitle": "All your users"
    },
    "dialog": {
      "inviteUser": {
        "title": "Invite User",
        "email": {
          "label": "Email"
        },
        "cancel": "Close",
        "invite": "Invite"
      }
    },
    "table": {
      "action": {
        "grantAdmin": {
          "label": "Grant Admin"
        },
        "revokeAdmin": {
          "label": "Revoke Admin"
        },
        "inviteUser": {
          "label": "Invite User"
        }
      },
      "column": {
        "user": {
          "label": "User"
        },
        "isAdmin": {
          "label": "Is Admin?"
        }
      }
    }
  },
  "environments": {
    "field": {
      "displayName": {
        "label": "Environment Name"
      },
      "uid": {
        "label": "Environment ID"
      },
      "instanceUrl": {
        "label": "Environment URL"
      },
      "owner": {
        "label": "Owner"
      },
      "environmentSku": {
        "label": "Type"
      },
      "createdBy": {
        "label": "Created By"
      },
      "createdAt": {
        "label": "Created At"
      },
      "updatedAt": {
        "label": "Updated At"
      },
      "region": {
        "label": "Region"
      }
    },
    "table": {
      "action": {
        "info": "See info"
      },
      "flag": {
        "filledCompliance": {
          "label": "Yes",
          "tooltip": "Filled compliance"
        },
        "filledComplianceNot": {
          "label": "No",
          "tooltip": "Not filled compliance"
        },
        "enableInventory": {
          "label": "Inv",
          "tooltip": "Inventory",
          "labelLong": "Include in inventory",
          "description": "Artifacts within this environment will undergo indexing when this option is enabled. No additional actions will be triggered; instead, this option solely functions to incorporate artifacts into the inventory."
        },
        "enableInactivity": {
          "label": "Inac",
          "tooltip": "Inactivity",
          "labelLong": "Inactivity Notifications",
          "description": "Users who possess artifacts within this environment will receive prompts to maintain the artifact's activation."
        },
        "enableCompliance": {
          "label": "Comp",
          "tooltip": "Compliance",
          "labelLong": "Enable Compliance",
          "description": "Users will be notified of compliance updates when new artifacts are created within this environment."
        },
        "enableQuarantine": {
          "label": "Quar",
          "tooltip": "Quarantine",
          "labelLong": "Enable Quarantine",
          "description": "Artifacts generated by the user will be placed in quarantine in the event of non-compliance or prolonged inactivity."
        },
        "enableCleanup": {
          "label": "Clean",
          "tooltip": "Cleanup",
          "labelLong": "Enable Cleanup",
          "description": "This environment will undergo cleanup in the absence of any further activity or when it becomes empty."
        }
      },
      "column": {
        "name": {
          "label": "Name"
        },
        "created": {
          "label": "Created"
        },
        "lastModified": {
          "label": "Modified"
        },
        "environmentSku": {
          "label": "Type"
        },
        "owner": {
          "label": "Owner"
        },
        "createdBy": {
          "label": "Created by"
        },
        "location": {
          "label": "Location"
        },
        "enabledPermissions": {
          "label": "Enabled permissions"
        }
      }
    }
  },
  "common": {
    "entity": {
      "ENVIRONMENT": {
        "overview": {
          "title": "Environments",
          "subtitle": "All your environments"
        }
      },
      "APP": {
        "overview": {
          "title": "Apps",
          "subtitle": "All your apps"
        }
      },
      "FLOW": {
        "overview": {
          "title": "Flows",
          "subtitle": "All your flows"
        }
      },
      "DESKTOPFLOW": {
        "overview": {
          "title": "Desktop Flows",
          "subtitle": "All your desktop flows"
        }
      },
      "BOT": {
        "overview": {
          "title": "Bots",
          "subtitle": "All your bots"
        }
      }
    },
    "field": {
      "environmentId": {
        "label": "Environment Id"
      },
      "environmentDisplayName": {
        "label": "Environment Name"
      }
    },
    "info": {
      "tab": {
        "overview": {
          "label": "Overview"
        },
        "preview": {
          "label": "Preview"
        },
        "preferences": {
          "label": "Preferences"
        },
        "compliance": {
          "label": "Compliance"
        }
      },
      "forms": {
        "complianceForm": {
          "message": {
            "noFormActive": "There is no compliance form active. Please create first one under Compliance Management and set it as active",
            "noFilledForm": "No compliance form has been filled yet",
            "newFormVersionAvailable": "A new form version is available",
            "noManualApprovalRequired": "Form will be automatically approved",
            "manualApprovalRequired": "Form will require manual approval",
            "lastUpdatedOn": "Last Updated on: ",
            "manuallyApprovedAt": "Manually approved on: ",
            "updatedSuccessFully": "The compliance form has been submitted successfully",
            "approvedSuccessFully": "The compliance form has been approved successfully",
            "activateAnotherFirstToModify": "Activate another form first before modifying this one"
          },
          "modal": {
            "preview": {
              "title": "Compliance form"
            },
            "fillNew": {
              "title": "Compliance form"
            }
          },
          "status": {
            "ACTIVE": "Active",
            "PENDING": "Pending approval",
            "PREVIOUS": "Previous"
          },
          "button": {
            "fillNew": {
              "label": "Fill new form"
            },
            "preview": {
              "label": "Preview"
            },
            "approve": {
              "label": "Approve"
            },
            "submit": {
              "label": "Submit"
            }
          }
        }
      }
    },
    "table": {
      "column": {
        "filledCompliance": {
          "label": "Compliance",
          "featuredFilter": {
            "defaultLabelSummary": "All",
            "filterLabel": "Status:",
            "optionsPlaceholder": "Select statuses"
          }
        }
      }
    }
  },
  "apps": {
    "field": {
      "appType": {
        "label": "App Type"
      },
      "appPlanClassification": {
        "label": "App Classification"
      }
    },
    "table": {
      "action": {
        "info": "See info"
      },
      "flag": {
        "filledCompliance": {
          "label": "Yes",
          "tooltip": "Filled compliance"
        },
        "filledComplianceNot": {
          "label": "No",
          "tooltip": "Not filled compliance"
        }
      },
      "column": {
        "name": {
          "label": "Name"
        },
        "created": {
          "label": "Created"
        },
        "lastModified": {
          "label": "Modified"
        },
        "environment": {
          "label": "Environment"
        },
        "owner": {
          "label": "Owner"
        },
        "createdBy": {
          "label": "Created by"
        },
        "appType": {
          "label": "App type"
        },
        "filledCompliance": {
          "label": "Compliance"
        }
      }
    }
  },
  "flows": {
    "table": {
      "action": {
        "info": "See info"
      },
      "flag": {
        "filledCompliance": {
          "label": "Yes",
          "tooltip": "Filled compliance"
        },
        "filledComplianceNot": {
          "label": "No",
          "tooltip": "Not filled compliance"
        }
      },
      "column": {
        "name": {
          "label": "Name"
        },
        "created": {
          "label": "Created"
        },
        "lastModified": {
          "label": "Modified"
        },
        "environment": {
          "label": "Environment"
        },
        "createdBy": {
          "label": "Created by"
        },
        "owner": {
          "label": "Owner"
        },
        "appType": {
          "label": "App type"
        },
        "filledCompliance": {
          "label": "Compliance"
        }
      }
    }
  },
  "formGenerator": {
    "header": {
      "title": "Form generator"
    },
    "element": {
      "input": {
        "label": "Input"
      },
      "password": {
        "label": "Password"
      },
      "date": {
        "label": "Date"
      },
      "file": {
        "label": "File"
      },
      "radio": {
        "label": "Radio"
      },
      "select": {
        "label": "Select"
      },
      "toggle": {
        "label": "Toggle"
      },
      "textarea": {
        "label": "Textarea"
      },
      "checkbox": {
        "label": "Checkbox"
      },
      "row": {
        "label": "Row"
      },
      "fieldset": {
        "label": "Fields group"
      },
      "fieldsArray": {
        "label": "Editable list"
      }
    },
    "hint": {
      "startDragging": "Start dragging a container here"
    },
    "itemCategory": {
      "elements": "Form inputs",
      "containers": "Containers",
      "selectItem": "Selected item"
    },
    "mode": {
      "design": "Design",
      "preview": "Peview"
    },
    "itemMode": {
      "uiElement": "All items",
      "selected": "Selected"
    },
    "buttons": {
      "removeElement": "Remove",
      "saveChanges": "Save changes"
    },
    "uiElement": {
      "id": {
        "label": "Id"
      },
      "key": {
        "label": "Key"
      },
      "labelProp": {
        "label": "Label"
      },
      "placeholderProp": {
        "label": "Placeholder"
      },
      "requiredProp": {
        "label": "Is Required?",
        "labelTrueValue": "Yes",
        "labelFalseValue": "No"
      },
      "fileAcceptProp": {
        "label": "Accepted files",
        "placeholder": "Ex: image/*,application/json"
      },
      "fileMaxFileSizeProp": {
        "label": "Max file size (Bytes)"
      },
      "toggle": {
        "defaultValue": "Default value",
        "labelTrue": "Label if true",
        "labelFalse": "Label if false"
      },
      "expressionsProp": {
        "hideExp": {
          "title": "Hidden",
          "info": "If hidden the field will not be displayed at all"
        },
        "requiredPropExp": {
          "title": "Required",
          "info": "If required the field needs to have a valid value"
        },
        "disabledPropExp": {
          "title": "Disabled",
          "info": "If disabled the field will not be editable"
        },
        "manualCompliancePropExp": {
          "title": "Manual compliance",
          "info": "If enabled the form will need to be reviewed by an admin"
        },
        "joinCondition": "Logical join",
        "conditions": "Conditions",
        "operator": "Operator",
        "operandLeft": "Left operand",
        "operandLeftType": "Type left operand",
        "operandLeftValue": "Value left operand",
        "operandRight": "Right operand",
        "operandRightType": "Type right operand",
        "operandRightValue": "Value right operand",
        "titleFieldset": "Expressions (Advanced)"
      },
      "optionsProp": {
        "titleFieldset": "Options",
        "id": {
          "label": "Value"
        },
        "name": {
          "label": "Text"
        }
      }
    }
  },
  "entity": {
    "overview": {
      "messages": {
        "syncingEnvironment" : "Syncing environments..."
      }
    },
    "details": {
      "needsActivityConfirmation": {
        "message": "Please confirm that the item is still active",
        "button": "Confirm activity"
      }
    }
  },
  "wiki": {
    "messages": {
      "successUpdate": "The url has been updated",
      "successDeleted": "The url has been deleted"
    }
  },
  "emailActions": {
    "messages": {
      "invalidOrExpired": "The email action is not valid anymore or has expired",
      "successAction": "The email action has been successfully performed. You can close the window"
    },
    "action": {
      "label": {
        "CONFIRMACTIVITY": "Confirm activity"
      }
    }
  },
  "login": {
    "orLabel": "- OR - ",
    "username": {
      "label": "Username"
    },
    "password": {
      "label": "Password"
    },
    "code": {
      "label": "Code"
    },
    "signIn": "Sign-In",
    "goBackLabel": "Go Back",
    "forgotPasswordLabel": "Forgot password?",
    "requestPasswordReset": {
      "button": "Request password reset",
      "error": "Error while requesting reset. Check the email entered and wait at least 30 min before trying again",
      "success": "An email with further instructions has been sent. Enter the code here"
    },
    "resetPassword": {
      "button": "Set new password",
      "error": "Error while setting password.",
      "success": "The password has been successfully set. You can login now"
    }
  },
  "ErrorInvalidCredentials": "Invalid credentials",
  "ErrorUnlinkedTenant": "Tenant is not linked anymore. Please link it from the dashboard",
  "ErrorMissingLinkingTenantRights": "The user is missing some rights to link the tenant",
  "ErrorMissingLinkingTenantRightsEnvironments": "The user is missing some rights to link the tenant in following environments: ",
  "test.label": "This is a test",
  "test.placeholder": "This is a placeholder",
  "test.tooltip": "This is a tooltip",
  "global": {
    "table": {
      "noItemsFound": "No items found",
      "yes": "Yes",
      "no": "No"
    },
    "notification": {
      "success": {
        "title": "Success"
      }
    }
  },
  "formsCommon": {
    "default": {
      "removeEntryIconTooltip": "Remove",
      "addEntryIconTooltip": "Add",
      "addEntryButtonLabel": "Add new entry"
    },
    "editor": {
      "title": "Form editor",
      "action": {
        "show": "Show form",
        "edit": "Edit form",
        "save": "Save",
        "close": "Close",
        "delete": "Delete",
        "import": "Import",
        "export": "Export",
        "download": "Download"
      }
    }
  },
  "enums": {
    "complianceStatus": {
      "options": {
        "PENDING": "Pending",
        "YES": "Yes",
        "NO": "No"
      }
    }
  },
  "Email": {
    "Footer": {
      "ReceivedEmailsAsUser": "You have received this email as a registered user of",
      "CompanyNumber": "Company number"
    },
    "ForgotPassword": {
      "Subject": "Impliancy forgot password request received",
      "ReceivedRequest": "We have received a password reset request for your account. In order to finish the process you need to enter this code:",
      "ResetPasswordButton": "Reset password"
    },
    "ConfirmReminders": {
      "Subject": "Impliancy confirm activity",
      "CheckFollowingEntries": "Following items require your attention. Please confirm the ones that are still active:",
      "ConfirmButton": "Confirm item activity"
    }
  },
  "tenantNotifications": {
    "ui": {
      "newLabel": "New"
    }
  },
  "NOTIFICATION": {
    "COMPLIANCE": {
      "FILLED": {
        "TITLE": "New compliance form submitted",
        "DESCRIPTION": "A compliance form has been filled and submitted by an user."
      },
      "APPROVAL_NEEDED": {
        "TITLE": "Manual compliance approval needed",
        "DESCRIPTION": "Please check the submitted form and approve it manually."
      }
    },
    "ACTION": {
      "VIEW": "View"
    }
  }
}
